module.exports = "../../app/cells/pages/landing_xray/index/options_cell.rb";